var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAbout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 2C4.89543 2 4 2.89543 4 4V9.04148C4.1626 9.0142 4.32964 9 4.5 9C4.67036 9 4.8374 9.0142 5 9.04148V4C5 3.44772 5.44772 3 6 3H10V6.5C10 7.32843 10.6716 8 11.5 8H15V16C15 16.5523 14.5523 17 14 17H8.96174C8.90868 17.3433 8.79987 17.6814 8.63157 18H14C15.1046 18 16 17.1046 16 16V7.41421C16 7.01639 15.842 6.63486 15.5607 6.35355L11.6464 2.43934C11.3651 2.15804 10.9836 2 10.5858 2H6ZM14.7929 7H11.5C11.2239 7 11 6.77614 11 6.5V3.20711L14.7929 7ZM6.5 12C6.5 13.1046 5.60457 14 4.5 14C3.39543 14 2.5 13.1046 2.5 12C2.5 10.8954 3.39543 10 4.5 10C5.60457 10 6.5 10.8954 6.5 12ZM8 16.5C8 17.7452 7 19 4.5 19C2 19 1 17.7499 1 16.5C1 15.6716 1.67157 15 2.5 15H6.5C7.32843 15 8 15.6716 8 16.5Z",
    fill: "#262626"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/about.a36e779c79061b14bd70ab5a93165556.svg";
export { ForwardRef as ReactComponent };